var map = {
	"./icons/Home.png": "ccbc",
	"./icons/all-icon.png": "438e",
	"./icons/all-inclusive.png": "46f2",
	"./icons/all-inclusive2.png": "06d9",
	"./icons/analytics-whi.png": "76ef",
	"./icons/beginners.png": "d1a5",
	"./icons/bet-whi.png": "7bec",
	"./icons/betcalc.png": "b98f",
	"./icons/betfinder.png": "569d",
	"./icons/bookmaker-whi.png": "105e",
	"./icons/bookmaker.png": "3d62",
	"./icons/browse.png": "1d07",
	"./icons/cashback.png": "e6cd",
	"./icons/clear.png": "8e9c",
	"./icons/download.png": "4651",
	"./icons/event-whi.png": "4051",
	"./icons/event.png": "a4ab",
	"./icons/freebies.png": "aeb5",
	"./icons/horses-mouth-small.png": "0728",
	"./icons/horses-mouth-whi.png": "8f45",
	"./icons/horses-mouth.png": "66d0",
	"./icons/intro.png": "8272",
	"./icons/knowledge-whi.png": "366d",
	"./icons/knowledge.png": "4159",
	"./icons/kyc.png": "f88d",
	"./icons/licensing.png": "24c3",
	"./icons/megafone.png": "d58d",
	"./icons/megafone2.png": "6c47",
	"./icons/old/all.png": "5735",
	"./icons/old/bets.png": "df85",
	"./icons/old/bonus.png": "8794",
	"./icons/old/bookmaker.png": "c31f",
	"./icons/old/cashback.png": "afc9",
	"./icons/old/extraplaces.png": "861a",
	"./icons/old/free.png": "72d7",
	"./icons/old/goododdsspot.png": "13b7",
	"./icons/old/horserelated.png": "f2ff",
	"./icons/old/odds.png": "44e8",
	"./icons/old/reports.png": "3416",
	"./icons/pete.png": "8626",
	"./icons/places.png": "2bff",
	"./icons/playersout.png": "6fea",
	"./icons/promo.png": "ec7e",
	"./icons/regular-promos.png": "797f",
	"./icons/save.png": "4b65",
	"./icons/sleep.png": "ef9c",
	"./icons/spot.png": "027a",
	"./images/18plus.png": "e68b",
	"./images/GambleAware Main.png": "791a",
	"./images/OddsGaloreLogoGrey.png": "f46f",
	"./images/OddsGalorelogo.png": "3bdf",
	"./images/btn_google_signin_light_normal_web.png": "f3b2",
	"./images/carousel/slidesmall.png": "168a",
	"./images/delete-26.png": "570b",
	"./images/download-26.png": "f987",
	"./images/fb_icon.png": "582f",
	"./images/lock-26.png": "6c42",
	"./images/menu-26.png": "8a47",
	"./images/password2-26.png": "8237",
	"./images/search-26.png": "5fbc",
	"./images/settings-26.png": "b37a",
	"./images/statistics.png": "624c",
	"./images/unlock-26.png": "9cf3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b5b";